import React, { FC } from 'react';
import { BatchImageProps } from '@v2/context/ProductionBatch/types';
import { ImageDocumentReference } from '@v2/components/imageHandling/types/types';
import { DOCUMENT_ENTITY_TYPE, IMAGE_HANDLING_CONTEXT, KEYS_TAGS, SCOPE_ID_TO_TAG_NAME } from '@components/imageHandling/common';
import { StyleSheet, View } from 'react-native';
import { scale } from '@components/frame';
import { LevelSubScreen } from '@v2/pages/common/enums';
import ImageContext from '@v2/context/Image/context';
import { getImageDimensions } from '@v2/context/ProductionBatch/tile/helpers';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

const BatchImage: FC<BatchImageProps> = ({ C, batch, elementSizeConfig: { large, middle, small }, onPress }) => {
  const { width, height } = getImageDimensions({ small, middle, large });

  const imageDocumentReferences: ImageDocumentReference[] = [
    {
      scopeId: KEYS_TAGS.Batch,
      scopeName: SCOPE_ID_TO_TAG_NAME[KEYS_TAGS.Batch],
      scopeReferenceId: batch.productionBatchId,
      scopeReferenceName: batch.batchNumber,
    },
    {
      scopeId: KEYS_TAGS.NcFile,
      scopeName: SCOPE_ID_TO_TAG_NAME[KEYS_TAGS.NcFile],
      scopeReferenceId: batch.ncFileId,
      scopeReferenceName: batch.ncFileName,
    },
  ];

  return (
    <View
      testID={TEST_IDS.searchScreen.productionBatches.infoTileImage}
      style={{
        width: scale(width + 2),
        height: scale(height + 2),
        borderColor: C('Hairline/Light/No trans'),
        borderRadius: scale(5),
        borderWidth: StyleSheet.hairlineWidth,
      }}
    >
      <ImageContext
        image={{
          documentId: batch.imageDocumentId,
          imageHash: batch.imageHash,
          contextId: batch.productionBatchId,
          imageData: batch.imageData,
          width: scale(width),
          height: scale(height),
          borderRadius: scale(4),
          isProcessing: false,
          contextCode: IMAGE_HANDLING_CONTEXT[DOCUMENT_ENTITY_TYPE.Batch],
        }}
        imageDocumentReferences={imageDocumentReferences}
        showImageControl={true}
        onPress={(event) => {
          onPress?.(batch, LevelSubScreen.DOCUMENTS);
          event?.stopPropagation();
        }}
      />
    </View>
  );
};

export default BatchImage;
